import { get } from '@client/lib/request';
import { RecommendationGender, Recommendation } from '@shared/types/recommendation';

export const getRecommendations = (gender: RecommendationGender): Promise<Recommendation[]> =>
    get(`/api/phoenix/recommendation/topseller/${gender}`);
